/**
 * Referral table column configuration
 */

import { ColumnConfig } from '../hooks/useTablePreferences';

export const referralColumns: ColumnConfig[] = [
  {
    key: 'logo',
    label: 'Logo',
    defaultWidth: 90,
    minWidth: 80,
    visible: true,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'name',
    label: 'Name',
    defaultWidth: 200,
    minWidth: 150,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'phone',
    label: 'Phone',
    defaultWidth: 150,
    minWidth: 120,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'email',
    label: 'Email',
    defaultWidth: 220,
    minWidth: 160,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'hash',
    label: 'Link Hash',
    defaultWidth: 200,
    minWidth: 150,
    visible: true,
    sortable: false,
    resizable: true,
    draggable: true,
  },
  {
    key: 'createdAt',
    label: 'Created',
    defaultWidth: 120,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
];
